import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import ModalWrapper from 'components/ModalWrapper'
import { lang } from 'utils/helpers'

const AmbiguityConfigModal = ({ isOpen, toggle, consoleId, ambiguityText, updateBotHeader }) => {
  const [ambiguityTextValue, setAmbiguityText] = useState(ambiguityText || '')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState(null)

  const handleSave = async () => {
    if (error) setError(null)
    setIsSubmitting(true)

    if (!ambiguityTextValue) {
      setError('va_translation-languages_select-least-one')
      setIsSubmitting(false)
      return
    }

    try {
      await updateBotHeader(consoleId, { ambiguity_text: ambiguityTextValue })
      setIsSubmitting(false)
      setTimeout(toggle)
    } catch (error) {
      setIsSubmitting(false)
      setError('dashboard_error_save_configuration')
    }
  }

  return (
    <ModalWrapper
      id='ambiguityConfigModal'
      isOpen={isOpen}
      toggle={toggle}
      header={I18n.t('dashboard_ambiguity')}
      eventBtnTxt={I18n.t('dashboard_save')}
      eventBtn={handleSave}
      cancelBtnTxt={I18n.t('dashboard_cancel')}
      cancelBtn={toggle}
      isSubmitting={isSubmitting}
      body={
        <div className='ambiguity-config-modal'>
          <div className='ambiguity-config-modal__input-container'>
            <label>{lang('dashboard_text')}</label>
            <input
              type='text'
              placeholder={lang('dashboard_text')}
              value={ambiguityTextValue}
              onChange={event => setAmbiguityText(event.target.value)}
            />
          </div>
          {error && <p className='ambiguity-config-modal__error-message'>{I18n.t(error)}</p>}
        </div>
      }
    />
  )
}

export default AmbiguityConfigModal
